import { BffRequestBuilder } from "../helpers";
var Retriever = /** @class */ (function () {
    function Retriever(bff) {
        this.bff = bff;
    }
    Retriever.prototype.loadData = function (items, successCallback, errorCallback) {
        var _this = this;
        var request = BffRequestBuilder.buildEventsByEventIdForBetSlipRequest(items);
        return this.bff.getEventsByIdForBetslip(request)
            .then(function (response) {
            successCallback(_this.prepareData(response));
        })
            .catch(errorCallback);
    };
    Retriever.prototype.prepareData = function (response) {
        var items = [];
        response.markets.forEach(function (market) {
            var event = response.events.find(function (e) { return market.eventId === e.id; });
            if (!event || !market.selections) {
                return;
            }
            market.selections.forEach(function (selection) {
                items.push({
                    event: event || {},
                    market: market,
                    selection: selection
                });
            });
        });
        return items;
    };
    return Retriever;
}());
export { Retriever };
//# sourceMappingURL=retriever.js.map